import { z } from 'zod';

export const gameConfigStatusSchema = z.enum(['Active', 'Closed']);

export const gameConfigSchema = z.object({
  id: z.string().uuid().optional(),
  regionId: z.string().uuid(),
  prizeName: z.string().min(1, 'Le nom du lot est requis').max(100),
  winProbability: z.number().min(0).max(1, 'La probabilité doit être entre 0 et 1'),
  stockLimit: z.number().int().min(0),
  remainingStock: z.number().int().min(0).optional(),
  status: gameConfigStatusSchema.default('Active'),
  createdAt: z.date().optional(),
  updatedAt: z.date().optional(),
});

export type GameConfig = z.infer<typeof gameConfigSchema>;
export type GameConfigStatus = z.infer<typeof gameConfigStatusSchema>;

export const createGameConfigSchema = gameConfigSchema.omit({ 
  id: true, 
  remainingStock: true,
  createdAt: true, 
  updatedAt: true 
});

export const updateGameConfigSchema = gameConfigSchema.partial().omit({
  id: true,
  createdAt: true,
  updatedAt: true
});
